import { getTheme } from './themes.js';

// this might be consumed by some components directly
export const DEFAULT_THEME = getTheme('light');
